import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { ErrorBoundary } from './ErrorBoundary';
export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div>
        <ErrorBoundary>
          <NavMenu />
        </ErrorBoundary>
        <ErrorBoundary>
          <Container>
            {this.props.children}
          </Container>
        </ErrorBoundary>
      </div>
    );
  }
}
